import { gql } from "@apollo/client"

import seoFields from "./partials/seoFields"

export const pagesId = "page"
export const pagesCollection = "pageCollection"

export const ALL_PAGE_SLUGS = gql`
{
  ${pagesCollection} {
    items {
      slug
    }
  }
}
`
export const PAGE_DATA_BY_SLUG = gql`
query getPageBySlug ($slug: String!){
  ${pagesCollection}(
    where: { slug: $slug }
  ) {
    items {
      title
    }
  }
}
`
export const PAGE_METADATA_BY_SLUG = gql`
query getPageBySlug ($slug: String!){
  ${pagesCollection}(
    where: { slug: $slug }
  ) {
    items {
      title
      seo {
        ${seoFields}
      }
    }
  }
}
`
